module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container-fluid page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Acesso Parceiro\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n                Acesso exclusivo a Parceiros credenciados. Ainda não é parceiro?\n                "), _c('router-link', {
    staticClass: "text-light",
    attrs: {
      "to": "/seja-um-parceiro"
    }
  }, [_vm._v("Clique aqui.")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "card text-center col-lg-4 col-md-10 col-sm-12 p-0",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "pb-4",
    attrs: {
      "action": _vm.url_catalogo + '/app/auth/login_check',
      "method": "post"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-dark",
    attrs: {
      "to": "/seja-um-parceiro"
    }
  }, [_vm._v("\n                    Seja um Parceiro!\n                ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('b', [_vm._v("Acesso Parceiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Usuario")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "_username"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "_password"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290d6543","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/Acesso.vue
// module id = 870
// module chunks = 0